import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let submitSetting = class submitSetting extends Vue {};
__decorate([Prop({
  required: true
})], submitSetting.prototype, "data", void 0);
__decorate([Prop({
  default: false
})], submitSetting.prototype, "disabled", void 0);
submitSetting = __decorate([Component({
  name: "submitSetting"
})], submitSetting);
export default submitSetting;